const PLAYING_CLASS = 'playing';
const HIDDEN_CLASS = 'hidden';

function addVideoEventListeners(snlaVideoBlock) {
    const videoElement = snlaVideoBlock.querySelector('video');
    const videoPlayBtn = snlaVideoBlock.querySelector('button');

    videoElement.addEventListener('loadeddata', () => videoPlayBtn.classList.remove(HIDDEN_CLASS));

    videoPlayBtn.addEventListener('click', evt => {
        evt.preventDefault();

        if (videoElement.paused || videoElement.ended) {
            videoElement.play();
            videoPlayBtn.classList.remove(PLAYING_CLASS);
        } else {
            videoElement.pause();
            videoPlayBtn.classList.add(PLAYING_CLASS);
        }
    });
}

const snlaVideoBlocks = document.querySelectorAll('.wp-block-snla-cover-video');

for (let i = 0; i < snlaVideoBlocks.length; i++) {
    addVideoEventListeners(snlaVideoBlocks[i]);
}
